export default __webpack_public_path__ + "static/A4-2-2cd90a50b0374bb0d9635198eedc8167.jpg";